<template>
    <div>

        <div class="mb-3" v-if="eventData && eventData['request_object']">
            <b-link v-if="ability.can('read', 'Request')" :to="{ name: 'requestsDetail', params: { id: eventData['request'] } }"
                    class="h5 mb-4" >
                <b-icon icon="link45deg" class="mr-2"/>
                <span>Заявка №{{ eventData['request_object']['id'] }}</span>
                <span v-if="isMonitoring"> на мониторинг</span>
                <span v-else> на отлов</span>
            </b-link>
        </div>

        <b-form-row class="">
            <gallery :label="'Фото'"
                     :root-api-url="attachmentsUrl"
                     :can-update="hasAbilityToUpdateAttachments"
                     :max-files="4"
                     :accepts="photoGalleryAccepts"
                     :upload-immediately="true"
                     :max-size="20"
                     :kind="1"
                     :existing="Boolean(eventId)"
                     @files-uploaded="onFilesUploaded"
                     ref="photoGallery"
                     class="col-xs-12 col-sm-12 col-md-4 mb-sm-2">
            </gallery>

            <gallery :label="'Видео'"
                     :root-api-url="attachmentsUrl"
                     :can-update="hasAbilityToUpdateAttachments"
                     :max-files="1"
                     :accepts="videoGalleryAccepts"
                     :upload-immediately="true"
                     :max-size="10"
                     :kind="3"
                     :existing="Boolean(eventId)"
                     @files-uploaded="onFilesUploaded"
                     ref="videoGallery"
                     class="col-xs-12 col-sm-12 col-md-4">
            </gallery>
        </b-form-row>

        <b-form-row class="mt-3">
                <form-field
                        :label="getFieldLabel('address')"
                        class="col-xs-12 col-lg-10 col-xl-6 required"
                        :editable="isEditable('address')"
                        :feedback="liveFeedback('address')"
                        :value="form.addressObject && form.addressObject['human_readable_address'] ? form.addressObject['human_readable_address'] : 'Не указан'">

                    <template #value>
                        <map-box ref="map" :coordinates="selectedCoordinates" style="width: 100%; height: 500px"/>
                        <div class="clearfix p-1"></div>
                        <div class="col-12 p-0 m-0 d-flex align-items-center">
                            <div class="flex-grow-1 mr-2">{{ form.addressObject && form.addressObject['human_readable_address'] ? form.addressObject['human_readable_address'] : 'Не указан' }}</div>
                            <b-button variant="link" class="p-0" @click="onAddressFocus">
                                <img :src="focus" width="32"/>
                            </b-button>
                        </div>
                    </template>

                    <template #field>
                        <map-box ref="map" :coordinates="selectedCoordinates" v-on:map-clicked="onMapClicked" style="width: 100%; height: 500px"/>
                        <div class="clearfix p-1"></div>
                        <div class="col-12 p-0 m-0 d-flex">
                            <single-select name="address"
                                           ref="address"
                                           class="flex-grow-1 mr-2"
                                           v-model="form['addressObject']"
                                           :url="getAddressUrl"
                                           :label="getFieldLabel('address')"
                                           label-key="human_readable_address"
                                           :state="getValidationClass('address')"
                                           :has-pagination="false"
                                           :initial-filters="addressInitialFilters"
                                           v-on:select-search-init="onAddressSearchStart"
                                           v-on:select-changed="onAddressChanged"
                                           v-on:select-set="onAddressSet"
                                           v-on:select-cleared="onModelObjectSingleSelectCleared" />
                            <b-button variant="link" class="p-0" @click="onAddressFocus">
                                <img :src="focus" width="32"/>
                            </b-button>
                        </div>
                    </template>
                </form-field>
        </b-form-row>

        <b-form-row class="mt-3 col-xs-12 col-lg-8 p-0">
            <form-field :label="getFieldLabel('immobilizationType')"
                        class="col-xs-12 col-md-6"
                        :value="object.immobilizationType"
                        :editable="isEditable('immobilizationType')"
                        :feedback="liveFeedback('immobilizationType')">
                    <template #field>
                            <b-form-textarea
                                id="immobilizationType"
                                class="w-100"
                                 v-model="$v.form.immobilizationType.$model"
                                :state="validateState('immobilizationType')">
                            </b-form-textarea>
                    </template>
            </form-field>

            <form-field :label="getFieldLabel('report')"
                        class="col-xs-12 col-md-6 mt-3 mt-md-0"
                        :value="object.report"
                        :editable="isEditable('report')"
                        :feedback="liveFeedback('report')">
                    <template #field>
                            <b-form-textarea
                                id="report"
                                class="w-100"
                                 v-model="$v.form.report.$model"
                                :state="validateState('report')">
                            </b-form-textarea>
                    </template>
            </form-field>
        </b-form-row>

        <b-form-row class="mt-3 col-xs-12 col-lg-8 p-0">
            <form-field :label="getFieldLabel('distinctive')"
                        class="col-xs-12 col-md-6"
                        :value="object.distinctive"
                        :editable="isEditable('distinctive')"
                        :feedback="liveFeedback('distinctive')">
                    <template #field>
                            <b-form-textarea
                                id="distinctive"
                                class="w-100"
                                 v-model="$v.form.distinctive.$model"
                                :state="validateState('distinctive')">
                            </b-form-textarea>
                    </template>
            </form-field>
        </b-form-row>


    </div>
</template>

<script>
    import { ObjectComponentMixin } from "@/components/Forms/ObjectComponentMixin";
    import FormField from "../../../../components/Forms/FormField";
    import {CatchingEventAttributes} from "./catching";
    import Gallery from "../../../../components/Files/Gallery";
    import api from "../../../../api";
    import SingleSelect from "@/components/Select/SingleSelect";
    import {AttributeMixin} from "@/pages/AppPages/Events/AttributeMixin";
    import {mapGetters} from "vuex";
    import {ACTIVITIES} from "@/store/auth/auth";
    import MapBox from "@/components/Map/MapBox.vue";
    import {MapMixin} from "@/components/Map/mapMixin";

    export default {
        name: "CatchingAttributes",
        components: {MapBox, SingleSelect, Gallery, FormField },
        mixins: [ObjectComponentMixin, AttributeMixin, MapMixin],
        props: {
            initialData: {type: Object, default: () => {return {} } },
        },
        computed: {
            ...mapGetters(['ability']),
            attachmentsUrl() {
                if (this.eventId) {
                    const eventUrl = api.events.default.detail(this.eventId);
                    return api.events.attachments.list(eventUrl);
                }
                return api.attachments.default.list()
            },
            photoGalleryAccepts() { return ['image/jpeg', 'image/png', 'image/tiff'] },
            videoGalleryAccepts() { return ['video/mpeg', 'video/mp4'] },
            hasAbilityToUpdateAttachments() {
                return this.ability.can('update', 'CatchingEvent') && this.editable
            },
            isMonitoring() {
                return this.eventData['request_object']['activity'] === ACTIVITIES.MONITORING
            }
        },
        methods: {
            onFilesUploaded(uploadedIds) {
                this.$emit('files-uploaded', uploadedIds)
            },
            clearFormAndGallery() {
                this.clearForm();
                this.resetGallery();
            },
            resetGallery() {
                this.$refs.photoGallery.resetMessagesAndItems();
                this.$refs.videoGallery.resetMessagesAndItems();
            },
            onMunicipalityChanged(item) {
                const aboutToChange = this.toggleSelectedMunicipality(item);
                if (aboutToChange) {
                    this.form['address'] = null;
                    this.form['addressObject'] = {};
                    this.$v.form.address.$touch();
                    this.selectedCoordinates = {};
                    this.nearestAddressData = {}
                }
            },
            cancelAttributeChanges() {
                this.cancelChanges()
                this.setMapCoordinates(this.object.coordinates)
            }
        },
        beforeMount() {
            this.objectClass = CatchingEventAttributes;
            this.initObjectParams = this.initialData;
            if (this.eventData) {
                this.objectData = this.eventData.attributes;
                this.initObjectParams['eventId'] = this.eventData['id'];
                this.initObjectParams['authorOrganizationId'] = this.eventData['author_organization_id'];
            }
        },
        mounted() {
            const vm = this;
            vm.onMount();
            vm.resetForm().then(() => {
                vm.setMapCoordinates(vm.object.coordinates);
                if (vm.object.addressObject) {
                    vm.$emit('init-municipality-selected', vm.object.addressObject['municipality_object'])
                }
            });
        },
    }
</script>

<style scoped>

</style>